import api from '@/lib/axios';
import type { UserPointAccount } from '@/types/user';
import { createAiCreditsError, notifyAiCreditsRequired } from '@/lib/creditsGuard';
import type { CreditGateUiType } from '@/lib/creditsTracking';

export interface AiTaskCreditsGuardOptions {
  showCreditsModal?: boolean;
  creditsModalTitle?: string;
  creditsModalCopy?: string;
  creditsModalProductArea?: string;
  creditsModalSurface?: string;
  creditsModalStage?: string;
  creditsModalTrigger?: string;
  creditsModalUiType?: CreditGateUiType;
  creditsModalSource?: string;
  creditsModalOperation?: string;
  creditsModalMetadata?: Record<string, unknown>;
}

const getPointBalanceForAiTask = async () => {
  const account = (await api.post(
    '/lowcode-business/api/user/point/balance',
    {},
    { _suppressErrorToast: true },
  )) as UserPointAccount;
  const balance = Number(account?.balance ?? 0);
  return Number.isFinite(balance) ? balance : 0;
};

export const ensureAiTaskCredits = async (
  taskCode?: string | null,
  options: AiTaskCreditsGuardOptions = {},
) => {
  if (!String(taskCode || '').trim()) return;

  let balance: number;
  try {
    balance = await getPointBalanceForAiTask();
  } catch (error) {
    console.warn('[aiTaskCredits] Failed to check point balance before AI task:', error);
    return;
  }

  if (balance > 0) return;

  if (options.showCreditsModal) {
    notifyAiCreditsRequired({
      title: options.creditsModalTitle,
      copy: options.creditsModalCopy,
      productArea: options.creditsModalProductArea,
      surface: options.creditsModalSurface,
      stage: options.creditsModalStage,
      trigger: options.creditsModalTrigger || 'precheck',
      uiType: options.creditsModalUiType || 'modal',
      source: options.creditsModalSource || 'ai_task_credits_guard',
      operation: options.creditsModalOperation,
      taskCode,
      metadata: options.creditsModalMetadata,
    });
  }

  throw createAiCreditsError();
};
